<template v-if="!hide"><div class="tab" :class="tabFull ? 'tab--desktop': null" v-show="selectedTitle === title"><slot></slot></div></template>